import {useContext} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import AtomButton, {atomButtonColors, atomButtonDesigns} from '@s-ui/react-atom-button'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'

const FINANCING_TERMS_CONDITIONS_ID = 'mt-Detail-financingTerms'
const scrollParams = {behavior: 'smooth', block: 'center'}

const handleScrollToFinancingTerms = () => {
  const elementContactForm = document.getElementById(FINANCING_TERMS_CONDITIONS_ID)
  elementContactForm && elementContactForm.scrollIntoView(scrollParams)
}

export const FinancingInfoTermsPartner = ({financingData, isLink, isModal, onClickTerms}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const URL_STATICS_IMAGES = config.get('URL_STATICS_IMAGES')
  const {FINANCING_PARTNERS} = config.get('financing')

  const handleClickTerms = () => {
    onClickTerms()
    handleScrollToFinancingTerms()
  }

  const getLabelClass = isModal =>
    cx('mt-TableFinancingDetails-financingInfoItemLabel', {
      'mt-TableFinancingDetails-financingInfoItemLabel--modal': isModal
    })

  const isVwfs = financingData.lender === FINANCING_PARTNERS.VWFS
  const showLenderLogo = financingData.lender !== undefined
  return (
    <>
      <div className="mt-TableFinancingDetails-financingInfoItem">
        {isLink ? (
          <AtomButton
            className="mt-TableFinancingDetails-financingInfoLink"
            color={atomButtonColors.NEUTRAL}
            design={atomButtonDesigns.LINK}
            onClick={handleClickTerms}
          >
            {i18n.t('FINANCING_INFO.SEE_TC')}
          </AtomButton>
        ) : (
          <span className={getLabelClass(isModal)}>{i18n.t('FINANCING_INFO.PROVIDED_BY')}</span>
        )}
        {showLenderLogo && (
          <div className="mt-TableFinancingDetails-financingInfoItemImage">
            <AtomImage
              alt={financingData.lender}
              src={`${URL_STATICS_IMAGES}common/logos/${financingData.lender}.svg`}
            />
          </div>
        )}
      </div>
      {isModal && isVwfs && (
        <p className="mt-TableFinancingDetails-financingLenderInfo">{i18n.t('FINANCING_INFO.VWFS_EXTRA_INFO')}</p>
      )}
    </>
  )
}

FinancingInfoTermsPartner.propTypes = {
  financingData: PropTypes.shape({
    availableTerm: PropTypes.bool,
    capital: PropTypes.number,
    coefficient: PropTypes.number,
    commissionEur: PropTypes.number,
    dateFirstInstallment: PropTypes.string,
    dateSignup: PropTypes.string,
    fee: PropTypes.number,
    firstFee: PropTypes.number,
    hasSpecificLegalConditions: PropTypes.bool,
    id: PropTypes.string,
    lender: PropTypes.string,
    lifeInsuranceAmount: PropTypes.number,
    maxEntry: PropTypes.number,
    minEntry: PropTypes.number,
    openingExpenses: PropTypes.number,
    openingPercentage: PropTypes.number,
    tae: PropTypes.number,
    terms: PropTypes.number,
    tin: PropTypes.number,
    totalAmountDue: PropTypes.number,
    totalInterest: PropTypes.number,
    totalLoanAmount: PropTypes.number,
    totalLoanCost: PropTypes.number,
    totalPriceTerms: PropTypes.number,
    totalTermsAmount: PropTypes.number
  }).isRequired,
  isLink: PropTypes.bool,
  isModal: PropTypes.bool,
  onClickTerms: PropTypes.func
}
